import apiClient from './client'

/**
 * 产品相关 API
 */
export const productApi = {
  /**
   * 查询 eSIM 产品列表（不带电话号码）
   * @returns {Promise} 产品列表响应
   */
  queryEsimProductList() {
    return apiClient.get('products/query-esim-product-list-by-params/', {
      skipLoading: true,
    })
  },

  /**
   * 查询 SIM 产品列表（带电话号码）
   * @returns {Promise} 产品列表响应
   */
  querySimProductList() {
    return apiClient.get('products/query-esim-product-list-by-params/', {
      params: { has_phone_number: 1 },
      skipLoading: true,
    })
  },

  /**
   * 获取地区覆盖区域列表
   * @param {string} countryRegionCode 国家/地区代码
   * @returns {Promise} 覆盖区域列表响应
   */
  getCoverageArea(countryRegionCode) {
    return apiClient.get('countriesregions/get-countriesregions-coverage-area-by-code/', {
      params: { country_region_code: countryRegionCode }
    })
  },

  /**
   * 获取套餐运营商披露信息
   * @param {number|string} productId 产品 ID
   * @returns {Promise} 运营商披露响应
   */
  getNetworkOperators(productId) {
    return apiClient.get(`products/network-operators/${productId}/`, {
      skipLoading: true,
    })
  },
}
